// import Vue from "vue";
import { createStore } from "vuex";

import candidates from "./candidates.module";
import config from "./app.config.module";
import resourcing from "./resourcing.module";
import insights from "./insights.module";
import user from "./user.module";
import utils from "./utils.module";

// Vue.use(Vuex);

export default createStore({
  modules: {
    candidates,
    config,
    resourcing,
    insights,
    user,
    utils,
  },
});
